<template lang="pug">
#newsTop
  <div class="header"><img :src="newsBg"></div>
  .contents
    Pickup
    NewsList
</template>

<script>
import NewsList from './templates/news_list.vue'
import Pickup from './templates/pickup.vue'

export default {
  name: 'newsTop',
  components: {
    NewsList,
    Pickup
  },
  data () {
    return {
      newsBg: require('@/assets/images/news_top_bg.svg')
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
@import '../assets/stylesheets/variables';
@import '../assets/stylesheets/mixins';

.header {
  margin: 0px;
  width: 100%;

  img {
    width: 100%;
    @include bpOnlyPc() {
      height: 400px;
      object-fit: cover;
    }
    @include bpOnlySp() {
      height: 200px;
      object-fit: cover;
    }
  }
}

.contents {
  div {
    margin: 300px;
  }
}
.footer {
  @include bpOnlyPc() {
    flex-direction: row;
    justify-content: center;
  }
  @include bpOnlySp() {
    flex-direction: column;
    align-items: center;
  }
  display: flex;
  background: $buildNavy;
  color: $white;
  padding-bottom: 90px;
  font-size: 14px;
  font-weight: bold;
  &_link {
    @include bpOnlyPc() {
      margin-right: 60px;
    }
    @include bpOnlySp() {
      margin-bottom: 30px;
    }
    text-decoration: underline;
  }
}
</style>
